import api from '../../shared/AxiosConfig';

const login = (credentials) => api.post('/auth/login', credentials);
const register = (data) => api.post('/auth/register', data);
const logout = () => api.post('/auth/logout');
const refreshToken = (token) => api.post('/auth/generateToken', { refreshToken: token });

export const authApi = {
    login,
    register,
    logout,
    refreshToken
};
